import en from './en'

export default {
  en
}


// WEBPACK FOOTER //
// ./src/app/locale/index.js